import type { ComponentType } from "react";
import {
  AlertTriangle,
  ClipboardCheck,
  FileText,
  Network,
  TimerReset,
} from "lucide-react";

export type TabId = "map" | "identify" | "review" | "monitor" | "demonstrate";

export type OperatingLoopTab = {
  id: TabId;
  label: string;
  eyebrow: string;
  heading: string;
  description: string;
};

export const OPERATING_LOOP_TABS: OperatingLoopTab[] = [
  {
    id: "map",
    label: "Map",
    eyebrow: "Map",
    heading: "Map resources to workloads",
    description:
      "Automatically scan cloud resources and group them into workloads.",
  },
  {
    id: "review",
    label: "Review",
    eyebrow: "Review",
    heading: "Review with evidence",
    description:
      "Start privacy reviews with pre-filled evidence. Teams only answer questions that Truspecta cannot derive.",
  },
  {
    id: "identify",
    label: "Identify",
    eyebrow: "Identify",
    heading: "Identify privacy risks and obligations",
    description:
      "Identify privacy risks and obligations using real evidence from infrastructure and data flows.",
  },
  {
    id: "monitor",
    label: "Monitor",
    eyebrow: "Monitor",
    heading: "Know when workloads drift",
    description:
      "Automatically flag workloads that have privacy-impacting drift from your last review.",
  },
  {
    id: "demonstrate",
    label: "Demonstrate",
    eyebrow: "Demonstrate",
    heading: "Demonstrate compliance with evidence",
    description:
      "Automatically draft RoPAs and DPIAs from completed privacy reviews and collected evidence.",
  },
];

export const TAB_ICONS: Record<TabId, ComponentType<{ className?: string }>> = {
  map: Network,
  identify: AlertTriangle,
  review: ClipboardCheck,
  monitor: TimerReset,
  demonstrate: FileText,
};
